module.exports = __webpack_public_path__ + "static/media/main.fe49b4b3.png";